import React, { Component } from 'react'
import { Mutation } from 'react-apollo'
import Dropzone from 'react-dropzone'

// graphql
import uploadFile from 'graphql/mutations/uploadFile'

// material-ui components
import withStyles from 'material-ui/styles/withStyles'
import TextField from 'material-ui/TextField'
import FormControl from 'material-ui/Form/FormControl'
import Button from 'material-ui/Button'

import Error from 'material-ui-icons/Error'

// styles
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx'
import './Dati.css'


class DropzoneAllegato extends Component {
  constructor(props) {
    super(props)

    this.state = {
      nome: '',
      files: [],
      errorMessage: '',
      fileSaved: false
    }
  }

  handleChangeNome = nome => event => {
    this.setState({
      nome: event.target.value
    })
  }

  onDrop = files => {
    this.setState({
      files,
      errorMessage: ''
    })
  }

  onDropRejected = files => {
    this.setState({
      errorMessage: `Il file "${files[0].name}" è troppo grande: pesa ${this.renderFileSize(files[0].size)}`
    })
  }

  saveFile = (uploadFile, nome, files) => event => {
    console.log(nome, files[0])
    
    this.props.onSaved()
    
    this.setState({
      errorMessage: '',
      fileSaved: true
    })

    // uploadFile({
    //   variables: {
    //     name: nome,
    //     file: files[0]
    //   },
    // })
    // .then(() => {
    //   console.log('upload OK!')
    //   this.props.onSaved()
    //   this.setState({
    //     errorMessage: '',
    //     fileSaved: true
    //   })
    // })
    // .catch(error => {
    //   console.log(error.message)
    // })
  }

  removeFile = () => {
    this.setState({
      nome: '',
      files: [],
      errorMessage: '',
      fileSaved: false
    })
  }

  renderFileSize = size => {
    if (size < 1000) {
      return `${size} bytes`
    } else if (size >= 1000 && size < 1000000) {
      return `${(size/1000).toFixed()} KB`
    } if (size >= 1000000) {
      return `${(size/1000000).toFixed(1)} MB`
    }
  }


  render() {
    const { title } = this.props

    return (
      <div className="allegato">
        <h3>{title}</h3>

        {!this.state.fileSaved ?
          <Mutation mutation={uploadFile}>
            {uploadFile => (
              <div className="upload-form">
                <FormControl fullWidth>
                  <TextField label="Nome documento" value={this.state.nome} onChange={this.handleChangeNome()} />
                </FormControl>

                <div className="dropzone">
                  <Dropzone
                    onDrop={this.onDrop}
                    onDropRejected={this.onDropRejected}
                    accept=".jpg, .jpeg, .png, .pdf"
                    maxSize={300000} //300KB
                  >
                    {this.state.files.length === 0 ?
                      <span>
                        Clicca o trascina qui il file per caricarlo
                        <br />
                        <small>(Dimensione massima: 300 KB)</small>
                      </span>
                    :
                      this.state.files.map(f => <div key={f.name}>"{f.name}"<br /><small>{this.renderFileSize(f.size)}</small></div>)
                    }
                  </Dropzone>
                </div>
                {!!this.state.errorMessage &&
                  <div style={{ color: '#f50357', marginTop: 10 }}>
                    <Error style={{ float: 'left', marginRight: 10, width: 20, height: 20 }} />{this.state.errorMessage}
                  </div>
                }
                
                <Button className="save-button" disabled={!this.state.nome || this.state.files.length === 0} variant="raised" color="primary" onClick={this.saveFile(uploadFile, this.state.nome, this.state.files)}>Carica</Button>
              </div>
            )}
          </Mutation>
        :
          <div className="upload-complete">
            <h5>{this.state.nome}</h5>
            <div>
              {this.state.files.map(f => {
                return (
                  <span key={f.name}>
                    "{f.name}"
                    <br /><small>{this.renderFileSize(f.size)}</small>
                  </span>
                )
              })}
            </div>

            <Button variant="raised" color="secondary" onClick={this.removeFile}>Rimuovi allegato</Button>
          </div>
        }
      </div>
    )
  }
}

export default withStyles(extendedFormsStyle)(DropzoneAllegato)



// WEBPACK FOOTER //
// ./src/views/App/Clienti/DropzoneAllegato.jsx